import { styled, Box } from '@mui/material';

export const DashboardVariantV2CarrierContentCollectTabTrackingSelectionContainer =
  styled(Box)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  }));
